/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Err_Already_TitleInputs */

const es_cap_err_already_title = /** @type {(inputs: Cap_Err_Already_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya estás registrado`)
};

const gl_cap_err_already_title = /** @type {(inputs: Cap_Err_Already_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xa estás rexistrado`)
};

const en_cap_err_already_title = /** @type {(inputs: Cap_Err_Already_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already registered`)
};

/**
* | output |
* | --- |
* | "Already registered" |
*
* @param {Cap_Err_Already_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_err_already_title = /** @type {((inputs?: Cap_Err_Already_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Err_Already_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_err_already_title(inputs)
	if (locale === "en") return en_cap_err_already_title(inputs)
	return es_cap_err_already_title(inputs)
});